import { memo, useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { fetchActiveUser, getActiveUser } from "services/api/users";

import { TextField } from "ui/components/TextField/TextField";
import { EmailTextField } from "ui/components/TextField/EmailTextField";
import { Button } from "ui/components/Button/Button";
import { Loader } from "ui/components/Loader";

import { ProfileInfoCardProps } from "./types";
import ProfileEditCard from "./components/ProfileEditCard/ProfileEditCard";

const ProfileInfoCard: React.FC<ProfileInfoCardProps> = () => {
  const dispatch = useDispatch();

  const { user } = useSelector(getActiveUser);
  const [showEditModal, setShowEditModal] = useState<boolean>(false);

  const handleEditClick = useCallback(() => {
    setShowEditModal(true);
  }, []);

  const handleEditSuccess = useCallback(() => {
    setShowEditModal(false);
    dispatch(fetchActiveUser() as any);
  }, [dispatch]);

  const handleEditClose = useCallback(() => {
    setShowEditModal(false);
  }, []);

  if (!user) return <Loader isLoading={true}> </Loader>;

  return (
    <>
      <div className="flex flex-col xl:flex-row gap-6 xl:gap-32">
        <div className="flex flex-col flex-1 max-w-[300px] ">
          <div>
            <p className="text-base font-bold text-slate-600 py-3">
              Osobni podaci
            </p>
            <p className="text-sm">
              Vaše ime, prezime i email adresa.
            </p>
          </div>
        </div>
        <div className="flex justify-between items-center flex-1 px-3 my-3">
          <div className="flex flex-col min-w-[530px]">
            <div className="flex gap-4">
              <div className="mb-3 flex-1">
                <TextField
                  type="text"
                  name="firstName"
                  label="Ime"
                  placeholder=""
                  value={user.firstName}
                  cssClassName="bg-white"
                  disabled
                ></TextField>
              </div>
              <div className="mb-3 flex-1">
                <TextField
                  type="text"
                  name="lastName"
                  label="Prezime"
                  placeholder=""
                  value={user.lastName}
                  cssClassName="bg-white"
                  disabled
                ></TextField>
              </div>
            </div>
            <div className="mb-3">
              <EmailTextField
                type="email"
                name="email"
                label="Email"
                placeholder=""
                value={user.email}
                autoComplete="email"
                cssClassName="bg-white"
                disabled
              ></EmailTextField>
            </div>
          </div>
          <div>
            <Button
              variant="outlined"
              children="Uredi"
              onClick={handleEditClick}
              startIcon="/media/icons/plus.svg"
            />
          </div>
        </div>
      </div>
      <ProfileEditCard
        show={showEditModal}
        onSuccess={handleEditSuccess}
        onClose={handleEditClose}
      />
    </>
  );
};

export default memo(ProfileInfoCard);
